import { PublicClientApplication } from '@azure/msal-browser';
import AppConstants from '../constants/appConstants';

const msalConfig = {
  auth: {
    clientId: AppConstants.microsoftClientId,
    authority: AppConstants.microsoftAuthority,
    redirectUri: AppConstants.microsoftRedirectURI,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Single instance shared across the app
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize once
let initPromise = null;
export const initializeMsal = () => {
  if (!initPromise) {
    initPromise = msalInstance.initialize();
  }
  return initPromise;
};

